import "./RadioButton.scss";

interface IProps {
    label?: string;
    value: string | boolean;
    onChange: (value: any) => void;
    defaultValue?: boolean;
    checked: boolean;
    isError?: boolean;
    disabled?: boolean;
}

export const RadioButton = (props: IProps) => {
    return (
        <div
            className={`radiobutton radiobutton__container ${props.checked ? "radiobutton__container_active" : ""}`}
            onClick={() => !props.disabled && props.onChange(props.value)}
        >
            <span className="radiobutton__input" style={{ borderColor: props.isError ? 'red' : 'var(--widget-blue)' }} />
            <label className="radiobutton__label" style={{ color: props.isError ? 'red' : 'inherit' }}>{props.label}</label>
        </div>
    );
};
